var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gameHelp",on:{"click":function($event){$event.preventDefault();return _vm.exit.apply(null, arguments)}}},[_c('div',{staticClass:"gameHelp_content"},[_c('h2',[_vm._v("TIP")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }